import React from "react";
import { Box, Skeleton, useTheme } from "@mui/material";

interface DeveloperTrackSkeletonProps {
  count?: number;
}

const DeveloperTrackSkeletonCard: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        overflow: "hidden",
        border: "1px solid #dce4e9",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "16px",
          padding: "16px",
        }}
      >
        <Skeleton variant="text" width={140} height={22} />
        <Skeleton variant="circular" width={20} height={20} />
      </Box>

      {/* Details Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          padding: "12px 16px",
        }}
      >
        {/* User Card */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            padding: "12px 16px",
            border: "1px solid #dce4e9",
            borderRadius: "12px",
          }}
        >
          {/* Top Line */}
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Skeleton variant="rounded" width={44} height={44} sx={{ borderRadius: "8px" }} />
            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: "4px" }}>
              <Skeleton variant="text" width={100} height={20} />
              <Skeleton variant="text" width={120} height={18} />
            </Box>
            <Skeleton variant="rounded" width={32} height={32} sx={{ borderRadius: "8px" }} />
          </Box>

          {/* Phone Row */}
          <Skeleton variant="rounded" width="100%" height={36} sx={{ borderRadius: "8px" }} />
        </Box>
      </Box>

      {/* Stage Stepper */}
      <Box sx={{ padding: "12px", display: "flex", gap: 0 }}>
        {[1, 2, 3].map((_, index) => (
          <Box
            key={index}
            sx={{
              width: "88px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <Skeleton variant="rectangular" sx={{ flex: 1, height: "1px" }} />
              <Skeleton variant="rounded" width={16} height={16} sx={{ borderRadius: "3.2px" }} />
              <Skeleton variant="rectangular" sx={{ flex: 1, height: "1px" }} />
            </Box>
            <Skeleton variant="text" width={60} height={16} />
          </Box>
        ))}
      </Box>

      {/* Status Button */}
      <Box sx={{ padding: "12px" }}>
        <Skeleton variant="rounded" width="100%" height={36} sx={{ borderRadius: "8px" }} />
      </Box>
    </Box>
  );
};

const DeveloperTrackSkeleton: React.FC<DeveloperTrackSkeletonProps> = ({
  count = 3,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(320px, 336px))",
        gap: theme.nawy.spacing.md,
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <DeveloperTrackSkeletonCard key={index} />
      ))}
    </Box>
  );
};

export default DeveloperTrackSkeleton;
